import type { Theme } from '../../contract.js';
import { defaultLight, defaultDark } from './variants.js';

export const defaultTheme: Theme = {
  id: 'default',
  name: 'EVI Default',
  description: 'EVI brand green accents.',
  swatches: ['#0F0F10', '#22C55E', '#FFFFFF'],
  variants: { light: defaultLight, dark: defaultDark },
  unlockedByDefault: true,
  costPoints: 0,
  // Driver Themes ticket — default family routes to the WebGL orb
  // shader in the Initiative variant. Light mode uses the Satellite
  // Streets basemap (matches the existing PwaMapContainer light
  // default); dark mode uses standard-satellite so PwaMapContainer's
  // style.load gate applies the 'dusk' lightPreset for the night-globe
  // look. The two modes intentionally diverge — the dusk globe is the
  // Default dark signature, while light stays on the flatter
  // satellite-streets scene.
  mapStyle: {
    light: 'mapbox://styles/mapbox/satellite-streets-v12',
    dark: 'mapbox://styles/mapbox/standard-satellite',
  },
  // Theme charging sims v2: Initiative's active-charging animation is the
  // REAL interactive fluid simulation (SimChargingAnimation) — touch/drag
  // stirs the fluid like the reference WebGL fluid demo; idle emits pulsing
  // brand-green light bursts whose cadence rides the live charge power.
  // Variant here is the docstring default; the dispatcher resolves
  // fluid-initiative-dark / fluid-initiative-light from the runtime mode.
  chargingAnimation: 'shader',
  shaderKind: 'fluid',
  shaderVariant: 'fluid-initiative-dark',
};
